<template>
    <div class="mt-4">
        <div class="col-2 pt-4 float-left">
            <mercur-checkbox v-model="value.active">Active</mercur-checkbox>
        </div>
        <div class="col-6 float-left">
            <mercur-input required v-model="value.step" type="number" min="1" >Step</mercur-input>
        </div>
    </div>
</template>
<script>

export default {
    name: 'CatalogProductSettingCustomQuantities',
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        return {
            configuration: {
                active: false,
                step: null,
            },
        }
    },
    watch: {
        'value.step': {
            handler (newVal) {
                if (newVal === '') {
                    this.value.step = null
                } else {
                    const parsed = parseInt(newVal, 10)
                    if (!isNaN(parsed) && this.value.step !== parsed) {
                        this.value.step = parsed
                    }
                }
            },
            immediate: false,
        },
    },
}
</script>
<style scoped lang="scss">
.float-left {
    float: left;
    margin-left: -13px;
}
</style>
